/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RolleDetail { 
    titel: string;
    funktionsbereich_id: string;
    rolle_id: string;
    ist_externer_ansprechpartner?: boolean;
    ist_im_dienstplan_verborgen?: boolean;
    ist_im_veranstaltung_home_sichtbar?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

